import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Roadmap from './components/Roadmap';
import Services from './components/Services';
import SocialProof from './components/SocialProof';
import Testimonial from './components/Testimonial';
import BlogSection from './components/BlogSection';
import FreeStrategy from './components/FreeStrategy';
import Footer from './components/Footer';
import CaseStudies from './components/CaseStudies';

const HomePage = () => (
  <>
    <Hero />
    <Roadmap />
    <Services />
    <SocialProof />
    <Testimonial />
    <BlogSection />
    <FreeStrategy />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="bg-white min-h-screen text-gray-900 selection:bg-[#8cc63f]/30">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/case-studies" element={<CaseStudies />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;